module.exports = __webpack_public_path__ + "static/media/exhibition_small_img.b25c9779.jpg";